module.exports = __webpack_public_path__ + "img/pop_01.e68e2087.png";